import { ComponentType, lazy } from 'react'

export const lazyWithRetry = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) => {
  return lazy(async () => {
    try {
      return await factory()
    } catch (error: any) {
      const message = error.message?.toLowerCase() || ''

      // 다양한 브라우저 및 상황에 대응하는 키워드 목록
      const chunkFailedMessages = [
        'failed to fetch dynamically imported module', // Chrome/Edge 최신
        'loading chunk', // Webpack 구버전/일부 브라우저
        'error loading chunk', // 일반적인 청크 에러
        'importing a module script failed', // Safari/Firefox 일부 버전
        'missing', // 일부 404 상황
        'not found', // 일부 404 상황
      ]

      const isChunkError = chunkFailedMessages.some((msg) => message.includes(msg))

      if (isChunkError) {
        // 무한 새로고침 방지를 위해 sessionStorage 체크
        const storageKey = `retry-lazy-${window.location.hash}`
        const hasRetried = sessionStorage.getItem(storageKey)

        if (!hasRetried) {
          sessionStorage.setItem(storageKey, 'true')
          window.location.reload() // 페이지를 새로고침하여 최신 index.html을 받아옴
        }
      }
      throw error // 재시도 후에도 에러라면 ErrorBoundary로 넘김
    }
  })
}
